import React, { useContext } from "react";
import { useSelector } from "react-redux";

import { Navigate, Outlet, useLocation } from "react-router-dom";

const AuthLayout = () => {
    const location = useLocation();
    const { isAuthenticated } = useSelector((state) => state.jwtAuthreducer);
    return isAuthenticated ? (
        <Outlet />
    ) : (
        <Navigate
            to="/login"
            replace
            state={{ from: location }} // <-- current location so login can redirect back is desired
        />
    );
};

export default AuthLayout;